<template>
  <section class="signup">
    <auth-layout name="signup">
      <template #body>
        <div class="title">
          <h3 v-text="`SMART SOLUTION ${$t('common.b_signup')}`"></h3>
        </div>
        <div class="content">
          <form @submit.prevent="formSubmit">
            <fieldset>
              <legend v-text="$t('essential_information')"></legend>
              <dl class="inline">
                <dt v-text="$t('id_and_pw')"></dt>
                <dd class="block">
                  <input
                    id="email"
                    v-model="email"
                    type="email"
                    :class="{ error: errorIdMessage }"
                    :placeholder="$t('id_and_pw')"
                  />
                  <p class="error-message" v-html="errorIdMessage"></p>
                </dd>
              </dl>
              <dl class="inline">
                <dt v-text="$t('pw')"></dt>
                <dd class="block">
                  <input
                    id="password"
                    v-model="password"
                    type="password"
                    :class="{ error: errorPasswordMessage }"
                    :placeholder="$t('text_condition', { cnt: '8~13' })"
                  />
                  <p class="error-message" v-html="errorPasswordMessage"></p>
                </dd>
              </dl>
              <dl class="inline">
                <dt v-text="$t('common.t_pw_confirm')"></dt>
                <dd class="block">
                  <input
                    id="password_confirm"
                    v-model="password_confirm"
                    type="password"
                    :class="{ error: errorPasswordCheckMessage }"
                    :placeholder="$t('common.t_pw_confirm')"
                  />
                  <p
                    class="error-message"
                    v-html="errorPasswordCheckMessage"
                  ></p>
                </dd>
              </dl>
              <dl class="inline">
                <dt v-text="$t('common.t_name')"></dt>
                <dd class="block">
                  <input
                    id="name"
                    v-model="name"
                    type="text"
                    :class="{ error: errorNameMessage }"
                    :placeholder="$t('common.t_name')"
                  />
                  <p class="error-message" v-html="errorNameMessage"></p>
                </dd>
              </dl>
              <dl class="inline">
                <dt v-text="$t('phone')"></dt>
                <dd class="block">
                  <input
                    id="telno"
                    v-model="telno"
                    type="tel"
                    :class="{ error: errorPhoneMessage }"
                    :placeholder="$t('phone_desc')"
                  />
                  <p class="error-message" v-html="errorPhoneMessage"></p>
                </dd>
              </dl>
              <dl class="inline">
                <dt v-text="$t('common.t_company_name')"></dt>
                <dd class="block">
                  <input
                    id="shop_name"
                    v-model="shop_name"
                    type="text"
                    :class="{ error: errorCompanyMessage }"
                    :placeholder="$t('common.t_msg_insert_name')"
                  />
                  <p class="error-message" v-html="errorCompanyMessage"></p>
                </dd>
              </dl>
              <dl class="inline">
                <dt v-text="$t('common.t_s_franchise_code')"></dt>
                <dd class="block no-error-msg">
                  <input
                    id="franchise_code"
                    v-model="franchise_code"
                    type="text"
                    :placeholder="$t('common.t_fran_code')"
                  />
                </dd>
              </dl>
              <dl class="inline">
                <dt v-text="$t('sign_unit')"></dt>
                <dd class="block no-error-msg">
                  <select v-model="device_cnt">
                    <option
                      v-for="unit in signUnit"
                      :key="unit"
                      :value="unit"
                      v-text="`${unit}${$t('common.t_s_unit')}`"
                    ></option>
                  </select>
                </dd>
              </dl>
            </fieldset>
            <fieldset>
              <legend
                v-text="
                  `${$t('movie_list.sub_btn_select')} ${$t('infomation')}`
                "
              ></legend>
              <dl class="inline space-bottom">
                <dt v-text="$t('birth')"></dt>
                <dd class="inline">
                  <input
                    id="birth_year"
                    v-model="birth_year"
                    type="number"
                    :placeholder="$t('year_n_letter')"
                  />
                  <select v-model="birth_month" @change="setDayList">
                    <option
                      v-for="month in monthList"
                      :key="month"
                      :value="month"
                      v-text="`${month}${$t('common.d_month')}`"
                    ></option>
                  </select>
                  <select v-model="birth_day">
                    <option
                      v-for="day in dayList"
                      :key="day"
                      :value="day"
                      v-text="`${day}${$t('day')}`"
                    ></option>
                  </select>
                </dd>
              </dl>
              <dl class="inline">
                <dt v-text="$t('gender')"></dt>
                <dd>
                  <select v-model="gender">
                    <option value="M" v-text="$t('man')"></option>
                    <option value="W" v-text="$t('woman')"></option>
                  </select>
                </dd>
              </dl>
              <p class="error-message" v-html="errorYearMessage"></p>
            </fieldset>
            <div class="button-box">
              <Button
                type="submit"
                name="join"
                class="primary"
                :value="$t('common.b_signup')"
              />
            </div>
          </form>
        </div>
      </template>
    </auth-layout>
  </section>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import Cookies from 'js-cookie';
import { Common } from '@src/common';
import eve from '@src/commonEvent';
import authLayout from '@layouts/authLayout.vue';
import Button from '@components/Button.vue';

export default {
  name: 'signup',
  head: {
    title: {
      inner: 'Sign Up',
      separator: '|',
      complement: 'Smart Solution',
    },
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'Please Sign Up for Enjoying Smart Solution',
      },
    ],
  },
  components: {
    authLayout,
    Button,
  },
  data() {
    return {
      language: '',
      email: '',
      name: '',
      password: '',
      password_confirm: '',
      telno: '',
      shop_name: '',
      birth_year: undefined,
      birth_month: undefined,
      birth_day: undefined,
      device_cnt: '1',
      gender: undefined,
      franchise_code: '',
      signUnit: ['1', '2', '3', '4', '5'],
      monthList: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
      ],
      dayList: [],
      errorIdMessage: '',
      errorPasswordMessage: '',
      errorPasswordCheckMessage: '',
      errorNameMessage: '',
      errorPhoneMessage: '',
      errorCompanyMessage: '',
      errorYearMessage: '',
    };
  },
  created() {
    this.language = Cookies.get(Common.STORAGE_LANG);
    this.setDayList();
  },
  methods: {
    setDayList() {
      const month = this.birth_month !== undefined ? this.birth_month : '01';
      const maxDay = moment()
        .month(+month - 1)
        .daysInMonth();
      const days = _.range(1, maxDay + 1);
      this.dayList = _.map(days, (day) => {
        return day < 10 ? `0${day}` : `${day}`;
      });
    },

    checkForm() {
      this.errorIdMessage = '';
      this.errorPasswordMessage = '';
      this.errorPasswordCheckMessage = '';
      this.errorNameMessage = '';
      this.errorPhoneMessage = '';
      this.errorCompanyMessage = '';
      this.errorYearMessage = '';
      // 비밀번호 정규식, 영문 대소문자, 숫자, 특수문자 1자 이상 포함하여 8~16자 입력
      const passRule =
        /^.*(?=^.{8,13}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).*$/;
      // eslint-disable-next-line no-useless-escape
      const emailRule = /^[A-Za-z0-9_\.\-]+@[A-Za-z0-9\-]+\.[A-Za-z\-]+/;
      const telRule = /^([0-9]{1,})$/g;

      if (!this.email) {
        this.errorIdMessage = eve.Lang.t('common.d_email_input');
        document.getElementById('email').focus();
        return false;
      }

      if (!emailRule.test(this.email)) {
        this.errorIdMessage = eve.Lang.t('common.d_email_input');
        document.getElementById('email').focus();
        return false;
      }

      if (!this.password) {
        this.errorPasswordMessage = eve.Lang.t('common.d_pw_input');
        document.getElementById('password').focus();
        return false;
      }

      if (!passRule.test(this.password)) {
        this.errorPasswordMessage = eve.Lang.t('common.d_pw_type_check', {
          cnt_range: '8~13',
        });
        document.getElementById('password').focus();
        return false;
      }

      if (!this.password_confirm) {
        this.errorPasswordCheckMessage = eve.Lang.t('common.d_pw_input');
        document.getElementById('password_confirm').focus();
        return false;
      }

      if (this.password !== this.password_confirm) {
        this.errorPasswordCheckMessage = eve.Lang.t(
          'common.t_wrong_pw_confirm',
        );
        document.getElementById('password_confirm').focus();
        return false;
      }

      if (!this.name) {
        this.errorNameMessage = eve.Lang.t('common.d_input_name');
        document.getElementById('name').focus();
        return false;
      }

      if (!this.telno) {
        this.errorPhoneMessage = eve.Lang.t('common.t_msg_insert_telno');
        document.getElementById('telno').focus();
        return false;
      }

      if (!this.telno.match(telRule)) {
        this.errorPhoneMessage = eve.Lang.t('common.t_confirm_phone');
        document.getElementById('telno').focus();
        return false;
      }

      if (!this.shop_name) {
        this.errorCompanyMessage = eve.Lang.t('common.d_name_franchise');
        document.getElementById('shop_name').focus();
        return false;
      }

      if (
        (this.birth_year !== undefined && this.birth_year > moment().year()) ||
        (this.birth_year !== undefined && this.birth_year < 1900) ||
        (this.birth_year !== undefined && String(this.birth_year.length) > 5)
      ) {
        this.errorYearMessage = eve.Lang.t('birth_year_check');
        document.getElementById('birth_year').focus();
        return false;
      }

      return true;
    },

    formSubmit() {
      if (!this.checkForm()) return;

      let birthDay = '';
      if (
        this.birth_year !== undefined &&
        this.birth_month !== undefined &&
        this.birth_day !== undefined
      ) {
        birthDay = `${this.birth_year}${this.birth_month}${this.birth_day}`;
      }

      const newLang = this.language === 'ja' ? 'jp' : this.language;
      const userInfo = {
        email: this.email,
        name: this.name,
        password: this.password,
        telno: this.telno,
        shop_name: this.shop_name,
        birth: birthDay,
        gender: this.gender,
        lang: newLang,
        email_url: `${window.location.protocol}//${window.location.host}`,
        device_cnt: this.device_cnt,
      };
      if (this.franchise_code) userInfo.franchise_code = this.franchise_code;
      this.$store.dispatch('SIGNUP', userInfo);
    },
  },
};
</script>

<style scoped lang="scss">
.signup {
  p.error-message {
    margin-top: 8px;
    color: $invalid;
  }

  .title {
    padding: 18px 0;
    border-bottom: 1px solid $gray-e6;

    h3 {
      font-size: 14px;
      text-align: center;
    }
  }

  .content {
    padding: 16px 0;

    fieldset {
      margin: 8px 0;

      & + fieldset {
        margin-top: 24px;
      }

      legend {
        margin-bottom: 15px;
        color: $gray-48;
      }

      dl {
        dt {
          width: 100px;
          min-width: 100px;
          padding-bottom: 18px;
          font-size: 12px;
          color: $gray-88;
        }

        dd {
          width: 100%;
          font-size: 12px;

          &.block.no-error-msg {
            margin-bottom: 18px;
          }
        }

        &.space-bottom {
          padding-bottom: 18px;
        }
      }
    }

    .button-box {
      display: flex;
      width: 100%;
      padding: 12px 0;
    }
  }
}
</style>
